<template>
  <div class="header">
    <div class="inner">
      <div class="logo" @click="toHome">
        <img src="//cdnw2.acmcoder.com/release/www/2.0.1/images/logo.png" />
      </div>
      <div class="fr">
        <div class="fl">
          <el-menu
            :default-active="activeTab"
            :router="true"
            :show-timeout="100"
            @select="handleSelect"
            active-text-color="#29bdb9"
            background-color="#fff"
            class="el-menu-demo"
            mode="horizontal"
            ref="menu"
            text-color="#666"
          >
            <el-menu-item index="1" route="/home">首页</el-menu-item>
            <el-submenu
              :class="{ activeTab: activeTab == 2 }"
              index="2"
              route="/product"
            >
              <template slot="title"
                ><router-link index="3" to="/product" class="heada"
                  >产品</router-link
                ></template
              >
              <div class="menu-box">
                <product></product>
              </div>
            </el-submenu>
            <el-submenu :class="{ activeTab: activeTab == 3 }" index="3">
              <template slot="title"
                ><router-link index="3" to="/scene" class="heada"
                  >应用场景</router-link
                ></template
              >
              <div
                class="menu-box menu-ul dropdown"
                style="border-top: 4px solid #29bdb9"
              >
                <ul>
                  <li>
                    <router-link index="31" to="/scene?to=section1"
                      >批量校招考试</router-link
                    >
                  </li>
                  <li>
                    <router-link index="32" to="/scene?to=section2"
                      >企业社招考试</router-link
                    >
                  </li>
                  <li>
                    <router-link index="33" to="/scene?to=section3"
                      >员工晋升考核</router-link
                    >
                  </li>
                  <li>
                    <router-link index="34" to="/scene?to=section4"
                      >培训认证考核</router-link
                    >
                  </li>
                  <li>
                    <router-link index="35" to="/scene?to=section5"
                      >高校招生测评</router-link
                    >
                  </li>
                  <li>
                    <router-link index="36" to="/scene?to=section6"
                      >随堂练习检测</router-link
                    >
                  </li>
                  <li>
                    <router-link index="37" to="/scene?to=section7"
                      >专业知识竞赛</router-link
                    >
                  </li>
                  <li>
                    <router-link index="38" to="/scene?to=section8"
                      >海量题库刷题</router-link
                    >
                  </li>
                </ul>
              </div>
            </el-submenu>
            <el-menu-item index="4" route="/customer">客户案例</el-menu-item>

            <!-- <el-submenu
              popper-class="jiageMenu"
              :class="{ activeTab: activeTab == 5 }"
              index="5"
            >
              <template slot="title"
                ><router-link class="heada" index="5" to="/tariff/exam"
                  >价格</router-link
                ></template
              >
              <el-menu-item
                class="downloadSelect"
                index="51"
                route="/tariff/exam"
                >在线考试</el-menu-item
              >
              <el-menu-item index="52" route="/tariff/interview"
                >在线面试</el-menu-item
              >
            </el-submenu> -->
            <el-submenu :class="{ activeTab: activeTab == 6 }" index="6">
              <template slot="title"
                ><router-link class="heada" index="6" to="/practice/company"
                  >真题练习</router-link
                ></template
              >
              <el-menu-item
                class="downloadSelect"
                index="6-1"
                route="/practice/company"
                >名企真题</el-menu-item
              >
              <el-menu-item index="6-2" route="/practice/code"
                >在线编程</el-menu-item
              >
            </el-submenu>
            <el-menu-item index="7" route="/link/about">关于赛码</el-menu-item>
          </el-menu>
        </div>
        <div class="fl concat">
          <i class="iconfont icondianhua1"></i>
          <span v-html="webconfig.Landline">400-060-8006</span>
        </div>

        <div class="login">
          <loginB v-if="!isToC"></loginB>
          <loginC v-if="isToC"></loginC>
          <!-- <div class="lang-dropdown">
            <el-dropdown @command="handleCommand" placement="top">
              <span class="el-dropdown-link">
                {{ text }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(v, index) in ['CN', 'EN']"
                  :key="index"
                  :command="v"
                  >{{ v }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import product from './product'
import loginB from './login/to-b'
import loginC from './login/to-c'

export default {
  name: 'haader',
  components: {
    product,
    loginB,
    loginC,
  },
  data() {
    return {
      activeTab: '1',
      webconfig: {},
      text: 'CN',
      list: [
        { index: '1', route: '/home', category: 1, title: '' },
        {
          index: '2',
          route: '/product/exam',
          category: 2,
          title: '在线考试产品',
        },
        {
          index: '2',
          route: '/product/interview',
          category: 3,
          title: '在线面试产品',
        },
        { index: '3', route: '/scene', category: 11, title: '应用场景' },
        { index: '4', route: '/customer', category: 31, title: '客户案例' },
        {
          index: '51',
          route: '/tariff/exam',
          category: 32,
          title: '在线笔试价格',
        },
        {
          index: '52',
          route: '/tariff/interview',
          category: 34,
          title: '在线面试价格',
        },
        { index: '7', route: '/link/about', category: 33, title: '关于赛码' },
        { index: '0', route: '/link/concat', category: 35, title: '关于赛码' },
        { index: '0', route: '/link/state', category: 36, title: '免责声明' },
        {
          index: '0',
          route: '/link/publicity',
          category: 37,
          title: '免责声明',
        },
        {
          index: '6',
          route: '/practice/company',
          category: 6,
          title: '真题练习',
        },
        { index: '6', route: '/practice/code', category: 6, title: '真题练习' },
        {
          index: '6',
          route: '/practice/company-code',
          category: 6,
          title: '真题练习',
        },
      ],
      isToC: false,
    }
  },
  computed: {
    loadConfig() {
      return this.$store.state.app.config
    },
  },
  mounted() {
    if (this.$store.state.app.config && this.$store.state.app.config.concat) {
      this.webconfig = this.$store.state.app.config.concat
    }
    this.judgeRoute()
    this.routeChange()
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val != oldVal) {
          this.routeChange()
          this.judgeRoute()
        }
      },
      // 深度观察监听
      deep: true,
    },
    loadConfig(newVal, oldVal) {
      if (newVal.concat) {
        this.webconfig = newVal.concat
      }
    },
  },
  methods: {
    toHome() {
      this.$router.push({ path: '/home' })
      document.title =
        '在线考试产品 - 【赛码网】在线考试系统、在线面试系统-易用稳定专业'
    },
    handleCommand(v) {
      this.text = v
      if (v === 'EN') {
        location.href = location.href.replace('www', 'www-en')
      } else {
        location.href = location.href.replace('www-en', 'www')
      }
    },
    judgeRoute() {
      let path = this.$route.path
      if (path.indexOf('practice') > -1) {
        this.isToC = true
      } else {
        this.isToC = false
      }
    },
    setTab(category) {
      const post = {
        category: category,
      }
      this.$store.dispatch('setTab', post)
    },
    routeChange() {
      let path = this.$route.path
      let hasRoute = this.list.filter((item) => item.route == path)
      if (hasRoute.length > 0) {
        console.log('active menu index', hasRoute[0].index)
        this.activeTab = hasRoute[0].index
        const category = hasRoute[0].category
        this.setTab(category)
        try {
          if (hasRoute[0].title) {
            document.title =
              hasRoute[0].title +
              ' - ' +
              '【赛码网】在线考试系统、在线面试系统-易用稳定专业'
          }
        } catch (e) {}
      }
      if (
        this.$route.path != '/home' &&
        this.$route.path != '/product/interview'
      ) {
        this.$store.dispatch('setRightBar', true)
      }
      setTimeout(this.checkFooter, 200)
    },
    handleSelect(key, keyPath) {},
    checkFooter() {
      if (
        this.$route.path == '/practice/code' &&
        document.getElementsByClassName('footer')[0].offsetTop <
          window.innerHeight - 173
      ) {
        $('.footer').css('position', 'absolute')
      } else {
        $('.footer').css('position', '')
      }
      //$(".footer").css('position',"absolute")
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  background: #fff;
  height: 60px;
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 999;
  font-size: 18px;
  min-width: 1200px;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
  .logo {
    cursor: pointer;
    img {
      height: 45px;
    }

    float: left;
    margin: 6px 30px 0px 0px;
  }

  .inner {
    width: 1100px;
    margin: 0px auto;
    height: 60px;
    .fr {
      float: right;
    }
    .fl {
      float: left;
      .activeTab {
        a {
          color: #29bdb9;
        }
      }
      a {
        text-decoration: none;
        color: rgb(102, 102, 102);
        &:hover {
          color: #29bdb9;
        }
        &.heada {
          vertical-align: inherit;
        }
      }
    }

    .concat {
      line-height: 60px;
      font-size: 15px;
      color: #29bdb9;
      padding: 0px 20px;
    }

    .login {
      float: right;
      position: relative;
      .lang-dropdown {
        position: absolute;
        right: -100px;
        padding-top: 18px;
        transform: translate(-50%, 0);
        .el-dropdown {
          font-size: 16px;
        }
      }
    }
  }

  .menu-ui {
    float: left;
  }
}
</style>
<style>
.activeTab .el-submenu__title {
  color: #29bdb9 !important;
}
.menu-box.menu-ul li {
  clear: both;
  width: 100%;
  display: block;
  padding: 6px 20px;
}
.menu-box.menu-ul li a {
  color: rgb(102, 102, 102);
  text-decoration: none;
}
.menu-box.menu-ul li a:hover {
  color: #29bdb9;
}
.jiageMenu {
  margin-left: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue